// document.addEventListener("DOMContentLoaded", function () {
//   const productForm = document.querySelector(".product-form");
//   const productFormButton = document.querySelector(".product-form__add-btn");
//   const fixedStickyBar = document.getElementById("fixed-sticky-bar");
//   const footer = document.getElementById("footer");
//   const headerContainer = document.querySelector("header-container");

//   if (!productFormButton || !fixedStickyBar || !headerContainer || !productForm) {
//     return;
//   }
  
//   const headerHeight = headerContainer.offsetHeight;
//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           fixedStickyBar.classList.remove("show");
//           if (footer) footer.style.paddingBottom = "0";
//         } else {
//           fixedStickyBar.classList.add("show");
//           if (footer) footer.style.paddingBottom = "80px";
//         }
//       });
//     },
//     {
//       root: null,
//       rootMargin: `-${headerHeight}px 0px 0px 0px`,
//       threshold: 0,
//     }
//   );

//   observer.observe(productFormButton);

//   const btnSelectOptions = document.getElementById("sticky-select-options");
//   if (btnSelectOptions) {
//     btnSelectOptions.addEventListener("click", function () {
//       productForm.scrollIntoView({ behavior: "smooth", block: "center" });
//     });
//   }
//   const btnAddToCart = document.getElementById("sticky-add-to-cart");
//   if (btnAddToCart) {
//     btnAddToCart.addEventListener("click", function () {
//       if (productFormButton) productFormButton.click();
//     });
//   }
// });


function initStickyBar() {
  const productForm = document.querySelector(".product-form");
  const productFormButton = document.querySelector(".product-form__add-btn");
  const fixedStickyBar = document.getElementById("fixed-sticky-bar");
  const footer = document.getElementById("footer");
  const variantSection = document.querySelector('[class*="variant_picker"]');

  if (!productFormButton || !fixedStickyBar || !productForm || !variantSection) {
    return;
  }

  function getOffsetTop(el) {
    let offset = 0;
    while (el) {
      offset += el.offsetTop;
      el = el.offsetParent;
    }
    return offset;
  }

  function toggleStickyBar() {
    const triggerPoint = getOffsetTop(variantSection);
    const scrollPosition = window.scrollY + window.innerHeight;

    if (scrollPosition >= triggerPoint + 100) {
      fixedStickyBar.classList.add("show");
      if (footer) footer.style.paddingBottom = "80px";
    } else {
      fixedStickyBar.classList.remove("show");
      if (footer) footer.style.paddingBottom = "0";
    }
  }

  // 🔥 IMPORTANT: initial hide (fix for editor)
  fixedStickyBar.classList.remove("show");

  window.addEventListener("scroll", toggleStickyBar);
  window.addEventListener("load", toggleStickyBar);

  toggleStickyBar(); // run once

  // buttons
  const btnSelectOptions = document.getElementById("sticky-select-options");
  if (btnSelectOptions) {
    btnSelectOptions.addEventListener("click", function () {
      productForm.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  const btnAddToCart = document.getElementById("sticky-add-to-cart");
  if (btnAddToCart) {
    btnAddToCart.addEventListener("click", function () {
      if (productFormButton) productFormButton.click();
    });
  }

  // const buttons = document.querySelectorAll("#sticky-select-options, #sticky-add-to-cart");

  // buttons.forEach((el) => {
  //   el.addEventListener('click', function () {
  //     if (productFormButton) productFormButton.click();
  //   });
  // });

}

// normal load
document.addEventListener("DOMContentLoaded", initStickyBar);

// 🔥 Shopify editor fix
document.addEventListener("shopify:section:load", initStickyBar);
document.addEventListener("shopify:section:select", initStickyBar);